module.exports = __webpack_public_path__ + "static/banner-text-e4de9f29cdcb2f3c5cbb5c38146fa1ee.png";